module.exports = __webpack_public_path__ + "static/media/four.54f16c12.svg";